import React, { useState, useRef, useEffect } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import {
  Container,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "react-bootstrap";
import { FaCaretUp, FaCaretDown } from "react-icons/fa";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { MdInfoOutline } from "react-icons/md";
import { TbWorld } from "react-icons/tb";
import { GrNotes } from "react-icons/gr";
import Bitcoinmarket from "../Component/bitcoinmarket";
import { Slider } from "rsuite";
import "rsuite/dist/rsuite-no-reset.min.css";
import { Link, useLocation, useParams } from "react-router-dom";
import { MdCandlestickChart } from "react-icons/md";
import { TiChartLine } from "react-icons/ti";
import { LuChartSpline } from "react-icons/lu";
import Select from "react-select";
import Tradingmodal from "../Modal/Tradingmodal";
import StockPriceChart from "../Component/Charts/pricemovement";
import CandleStickChart from "../Component/Charts/pricecandlestick";
import ChartTimeline from "../Component/Charts/marketcap1";
import Coindetaildash from "../Component/Coindetaildash";
import {
  getCandlestick,
  getCoinDetail,
  getMarketpairlist,
} from "../Actions/v1/user";
import { formatDate, formatNumber, isEmpty } from "../Actions/commonFunction";
import { socket } from "../Hooks/Socket";

var detail = {} 
function Coindetail() {
  const params = useParams();
  console.log("🚀 ~ Coindetail ~ params:", params);

  const datas = [
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Ethernet",
      shortname: "ETH",
      symbol: Images.eth,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
    {
      name: "Bitcoin",
      shortname: "BTC",
      symbol: Images.bnb,
      pair: "BTC/USDT",
      price: "$95,552.33",
      volume24h: "$455,831,211",
      volumeper: "1.19%",
    },
  ];
  const options = [
    { value: "Etherum", label: "Etherum" },
    { value: "BNB", label: "BNB" },
    { value: "Solana", label: "Solana" },
  ];
  const [selectedhour, setSelectedhour] = useState({ name: "24h" });
  const times = [{ name: "24h" }, { name: "1m" }, { name: "1y" }];
  const handleSelecthour = (e) => {
    setSelectedhour(e);
  };
  const [tabs, setTabs] = useState("chart");
  const [pricetabs, setPricetabs] = useState("price");
  const [graphtabs, setGraphtabs] = useState("line");
  const [daystabs, setDaystabs] = useState("1d");
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSearchable] = useState(true);
  const [trademodal, setTrademodal] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(6);
  const [usdPrice, setUsdPrice] = useState(0);
  const [firstcur, setfirstcur] = useState();
  const [usd, setUsd] = useState(0);
  // coinsDetails
  const [ coindetail, setCoinDetail] = useState({});
  console.log("🚀 ~ Coindetail ~ coindetail:", coindetail);
  const [candlestickData, setCandlestickData] = useState({});
  const [marketData, setMarketData] = useState([]);
  const [chartData, setChartData] = useState([]);
  console.log("🚀 ~ Coindetail ~ chartData:", chartData);
  console.log("🚀 ~ Coindetail ~ candlestickData:", candlestickData);

  const onchangefunc = (value, isUsd) => {
    if (isUsd) {
      setUsd(value);
      setfirstcur(Number(value) / Number(usdPrice));
    } else {
      setfirstcur(value);
      setUsd(Number(value) * Number(usdPrice));
    }
  };

  const dates = [
    [1625097600000, 10000000],
    [1625184000000, 12000000],
    [1625270400000, 15000000],
  ];

  const sectionRef = useRef(null);

  const handleScroll = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Get Coin Details
  const getCoindetail = async (tokenid = params?.tokenId) => {
    let resp = await getCoinDetail({ tokenid });
    console.log("🚀 ~ getCoindetail ~ resp:", resp);
    if (resp?.status) {
      setCoinDetail(resp?.data?.data);
      let data = resp?.data?.data
      detail = resp.data.data;
      setUsdPrice(data?.usdPrice);
      setUsd(data?.usdPrice);
      setfirstcur("1");
      setChartData(resp?.data?.data?.chartdata);
    }
  };

  const getMarketPairs = async () => {
    let resp = await getMarketpairlist({
      page: currentPage,
      limit,
      tokenid: coindetail?._id,
    });
    console.log("resp111-->", resp);
    if (resp.status) {
      setMarketData(resp.data.marketData);
    }
  };

  const getCandlestickData = async (timeline) => {
    console.log("🚀 ~ getCandlestickData ~ timeline:", timeline);
    console.log("candlestickData[timeline]-->", candlestickData[timeline]);
    if (candlestickData[timeline] == undefined) {
      let resp = await getCandlestick({
        tokenid: coindetail?._id,
        timeline,
      });
      console.log("🚀 ~ getCandlestickData ~ resp:", resp);
      if (resp.status) {
        setCandlestickData({ ...candlestickData, [timeline]: resp?.data?.[0] });
      }
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (params.tokenId) {
      getCoindetail(params.tokenId);
    }
  }, [params.tokenId]);

  useEffect(() => {
    if (!isEmpty(coindetail)) {
      getMarketPairs();
      getCandlestickData("1d");
    }
  }, [coindetail]);

  useEffect(() => {
    if (selectedhour?.name && !isEmpty(coindetail)) {
      getCandlestickData(
        selectedhour?.name == "24h" ? "1d" : selectedhour?.name
      );
    }
  }, [selectedhour?.name, coindetail]);

  useEffect(() => {
    if (daystabs && !isEmpty(coindetail)) {
      getCandlestickData(daystabs);
    }
  }, [daystabs]);
  const socketpriceupdate = (data)=>{
    if (!Array.isArray(data) && detail?._id == data?._id) {
      setCoinDetail({
        ...detail,
        ["price"]: data?.price,
        ["usdPrice"]: data?.usdPrice,
      });
  }
}
  useEffect(() => {
    socket.on("pricechange", (data) => {
      socketpriceupdate(data)
    });
  }, [socket]);

  return (
    <div>
      {trademodal && <Tradingmodal onDismiss={() => setTrademodal(false)} />}
      <div>
        <Header />
        <div className="inner_page">
          <img src={Images.elogo} className="elogo" alt="elogo" />

          <Container className="mt-4">
            <Row className="flexreverse coin_check">
              <Col lg={5} xl={4} xxl={3}>
                <div className="scrollset">
                  <div className="d-none d-lg-block">
                    <Coindetaildash
                      coindetail={{
                        _id: coindetail?._id,
                        name: coindetail?.name,
                        symbol: coindetail?.symbol,
                        tradevolume: coindetail?.voluem_24h,
                        percent: coindetail?.percent_24h,
                        logo: coindetail?.logo,
                        price: coindetail?.price,
                        usdPrice: coindetail?.usdPrice,
                        wishcount: coindetail?.wishcount ?? 0,
                      }}
                      getcoin={getCoindetail}
                    />
                  </div>

                  <p className="mt-3 coindet_p">
                    {coindetail?.shortdescription}
                    {/* Bitcoin (BTC) is a cryptocurrency (a virtual currency)
                    designed to act as money and a form of payment outside the
                    control of any one person, group, or entity. This removes
                    the need for trusted third-party involvement (e.g., a mint
                    or bank) in financial transactions. */}
                  </p>

                  <div className="maincoin pt-2 pb-3 px-3">
                    <Row>
                      <Col sm={6} xl={6}>
                        <div className="markets py-2 px-2 text-center mt-3">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip
                                id="tooltip-top"
                                className="custom-tooltip"
                              >
                                The total market value of a cryptocurrency's
                                circulating supply. It is analogous to the
                                free-float capitalization in the stock market.
                                <br></br>
                                Market cap = Current price x Circulating supply
                              </Tooltip>
                            }
                          >
                            <h6>
                              Market Cap <MdInfoOutline />
                            </h6>
                          </OverlayTrigger>
                          <p className="mb-0">
                            $
                            {formatNumber(
                              Number(coindetail?.circulate_supply) *
                                Number(coindetail?.price)
                            )}{" "}
                            {/* <span className="redclr">
                              <FaCaretDown /> 7.08%
                            </span> */}
                          </p>
                        </div>
                      </Col>
                      <Col sm={6} xl={6}>
                        <div className="markets py-2 px-2 text-center mt-3">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip
                                id="tooltip-top"
                                className="custom-tooltip"
                              >
                                A measure of how much of a cryptocurrency was
                                traded in the last 24 hour
                              </Tooltip>
                            }
                          >
                            <h6>
                              Volume (24h) <MdInfoOutline />
                            </h6>
                          </OverlayTrigger>
                          <p className="mb-0">
                            ${formatNumber(Number(coindetail?.voluem_24h))}{" "}
                            <span className="tradeclr">
                              {Number(coindetail?.percent_24h?.current) >
                              Number(coindetail?.percent_24h?.last) ? (
                                <FaCaretUp />
                              ) : (
                                <FaCaretDown />
                              )}
                              ${formatNumber(Number(coindetail?.voluem_24h))}%
                            </span>
                          </p>
                        </div>
                      </Col>
                      <Col sm={6} xl={6}>
                        <div className="markets py-2 px-1 text-center mt-3">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip
                                id="tooltip-top"
                                className="custom-tooltip"
                              >
                                Total supply = Total coins created - coins that
                                have been burned (if any) It is comparable to
                                outstanding shares in the stock market.
                                {/* <br></br>
                                If the project did not submit this data nor was
                                it verified by CoinMarketCap, total supply shows
                                “--”. */}
                              </Tooltip>
                            }
                          >
                            <h6>
                              Total supply <MdInfoOutline />
                            </h6>
                          </OverlayTrigger>
                          <p className="mb-0">
                            {formatNumber(Number(coindetail?.total_supply))}{" "}
                            {coindetail?.symbol}
                          </p>
                        </div>
                      </Col>
                      <Col sm={6} xl={6}>
                        <div className="markets py-2 px-1 text-center mt-3">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip
                                id="tooltip-top"
                                className="custom-tooltip"
                              >
                                The maximum amount of coins that will ever exist
                                in the lifetime of the cryptocurrency. It is
                                analogous to the fully diluted shares in the
                                stock market.
                                {/* <br></br>
                                If the project did not submit this data nor was
                                it verified by CoinMarketCap, max. supply shows
                                "--". */}
                              </Tooltip>
                            }
                          >
                            <h6>
                              Max. supply <MdInfoOutline />
                            </h6>
                          </OverlayTrigger>
                          <p className="mb-0">
                            {formatNumber(Number(coindetail?.max_supply))}{" "}
                            {coindetail?.symbol}{" "}
                          </p>
                        </div>
                      </Col>
                      <Col xl={12}>
                        <div className="markets py-2 px-1 text-center mt-3">
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip
                                id="tooltip-top"
                                className="custom-tooltip"
                              >
                                The amount of coins that are circulating in the
                                market and are in public hands. It is analogous
                                to the flowing shares in the stock market.
                              </Tooltip>
                            }
                          >
                            <h6>
                              Circulating supply <MdInfoOutline />
                            </h6>
                          </OverlayTrigger>
                          <p className="mb-0">
                            {formatNumber(Number(coindetail?.circulate_supply))}{" "}
                            {coindetail?.symbol}{" "}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="listed mt-3">
                    <div className="justify-content-between">
                      <p className="mb-2">Website</p>

                      <div className="d-flex underline_none gap-2">
                        {coindetail?.websites &&
                          Object.keys(coindetail?.websites)?.map((val) => (
                            <Link
                              to={`${coindetail?.websites[val]}`}
                              target="_blank"
                            >
                              <p className="webs rounded-4 px-2 py-1">
                                <TbWorld /> {val}
                              </p>
                            </Link>
                          ))}
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p>Socials</p>
                      <div className="d-flex underline_none gap-2">
                        {coindetail?.social &&
                          Object.keys(coindetail?.social)?.map((val, i) => (
                            <Link
                              to={`${coindetail?.social[val]}`}
                              target="_blank"
                            >
                              <p className="webs rounded-4 px-2 py-1">
                                <img
                                  src={i == 0 ? Images.github : Images.reddit}
                                  alt="reddit"
                                />
                              </p>
                            </Link>
                          ))}
                      </div>
                    </div>
                    <p className="mb-1">
                      {coindetail?.symbol} to USD converter
                    </p>

                    <div className="maincoin pt-2 pb-2 px-3">
                      <div className="d-flex justify-content-between">
                        <p>{coindetail?.symbol}</p>
                        <input
                          type="text"
                          className="list_input"
                          value={firstcur}
                          onChange={(e) => onchangefunc(e.target.value)}
                        />
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="mb-0">USD</p>
                        <input
                          type="text"
                          className="list_input"
                          value={usd}
                          onChange={(e) => onchangefunc(e.target.value, true)}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-between mt-2">
                      <p>Price performance</p>
                      <Dropdown>
                        <DropdownToggle className="webs px-2 py-0">
                          {selectedhour.name}
                        </DropdownToggle>
                        <DropdownMenu className="inner_menu">
                          {times.map((e, i) => (
                            <DropdownItem
                              className="mb-1"
                              onClick={() => handleSelecthour(e)}
                            >
                              {e.name} Low / High
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                    <div className="d-flex justify-content-between mt-2">
                      <div>
                        <p className="mb-1">Low</p>
                        <p className="mb-0">
                          ${" "}
                          {
                            candlestickData?.[
                              selectedhour.name == "24h"
                                ? "1d"
                                : selectedhour.name
                            ]?.data?.[0]?.["y"]?.[2]
                          }{" "}
                        </p>
                      </div>
                      <div className="text-end">
                        <p className="mb-1">High</p>
                        <p className="mb-0">
                          $
                          {
                            candlestickData?.[
                              selectedhour.name == "24h"
                                ? "1d"
                                : selectedhour.name
                            ]?.data?.[
                              candlestickData?.[
                                selectedhour.name == "24h"
                                  ? "1d"
                                  : selectedhour.name
                              ]?.data?.length - 1
                            ]?.["y"]?.[1]
                          }
                        </p>
                      </div>
                    </div>
                    <hr></hr>
                    <div className="d-flex justify-content-between mt-2">
                      <p className="mb-1">All-time high</p>
                      <p className="mb-1">
                        ${coindetail?.all_time_high?.price}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between">
                      <p className="mb-1">
                        {formatDate(coindetail?.all_time_high?.date)}
                      </p>
                    </div>
                    <hr></hr>
                    <div className="d-flex justify-content-between mt-2">
                      <p className="mb-1">All-time low</p>
                      <p className="mb-1">${coindetail?.all_time_low?.price}</p>
                    </div>
                    <div className="d-flex justify-content-between mb-2">
                      <p className="mb-1">
                        {formatDate(coindetail?.all_time_low?.date)}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={7} xl={8} xxl={9} className="mt-3 mt-lg-0">
                <div className="scroll_list">
                  <div className="d-block d-lg-none mb-3">
                    <Coindetaildash />
                  </div>
                  <div className="maincoin markettab px-3 py-2">
                    <ul className="mb-0 ps-0 d-flex gap-5">
                      <li
                        className={tabs === "chart" ? "active" : ""}
                        onClick={() => setTabs("chart")}
                      >
                        Chart
                      </li>
                      <li
                        className={tabs === "market" ? "active" : ""}
                        onClick={() => (setTabs("market"), handleScroll())}
                      >
                        Markets
                      </li>
                    </ul>
                  </div>

                  <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-between my-3">
                    <div className="d-flex align-items-center gap-4">
                      <ul className="mb-0  d-flex maincoin rounded-2 px-1 py-1 pricetab gap-2">
                        <li
                          className={pricetabs === "price" ? "active" : ""}
                          onClick={() => setPricetabs("price")}
                        >
                          Price
                        </li>
                        <li
                          className={pricetabs === "market" ? "active" : ""}
                          onClick={() => setPricetabs("market")}
                        >
                          Market cap
                        </li>
                      </ul>
                      {pricetabs === "price" && (
                        <ul className="mb-0  d-flex maincoin rounded-2 px-1 py-1 pricetab gap-1">
                          <li
                            className={graphtabs === "line" ? "active" : ""}
                            onClick={() => setGraphtabs("line")}
                          >
                            <TiChartLine className="candlesvg" />
                          </li>
                          <li
                            className={graphtabs === "candle" ? "active" : ""}
                            onClick={() => setGraphtabs("candle")}
                          >
                            <MdCandlestickChart className="candlesvg" />
                          </li>
                        </ul>
                      )}
                    </div>

                    <div className="d-block d-sm-flex gap-2 mt-2 mt-xl-0">
                      <p
                        className="maincoin d_white rounded-1 py-2 px-2 mb-0 cursor-pointer"
                        onClick={() => setTrademodal(true)}
                      >
                        <LuChartSpline /> Trading view
                      </p>
                      <ul className="mb-0  d-flex maincoin rounded-2 px-1 py-1 pricetab gap-1 graphdays mt-2 mt-sm-0">
                        <li
                          className={daystabs === "1d" ? "active" : ""}
                          onClick={() => setDaystabs("1d")}
                        >
                          1D
                        </li>
                        <li
                          className={daystabs === "7d" ? "active" : ""}
                          onClick={() => setDaystabs("7d")}
                        >
                          7D
                        </li>
                        <li
                          className={daystabs === "1m" ? "active" : ""}
                          onClick={() => setDaystabs("1m")}
                        >
                          1M
                        </li>
                        <li
                          className={daystabs === "1y" ? "active" : ""}
                          onClick={() => setDaystabs("1y")}
                        >
                          1Y
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="maincoin py-2 px-2">
                    {pricetabs === "price" && graphtabs === "line" && (
                      <>
                        <StockPriceChart
                          dates={
                            chartData?.find((val) => val.history == daystabs)
                              ?.data
                          }
                        />
                      </>
                    )}
                    {pricetabs === "price" && graphtabs === "candle" && (
                      <>
                        <CandleStickChart
                          data={candlestickData?.[daystabs]?.data}
                        />
                      </>
                    )}
                    {pricetabs === "market" && (
                      <>
                        <ChartTimeline
                          dates={
                            chartData?.find((val) => val.history == daystabs)
                              ?.marketcap
                          }
                        />
                      </>
                    )}
                  </div>
                  <div className="d-flex gap-4 mt-3 mb-3">
                    <button className="btn sellbtn w-100">Sell at P2P</button>
                    <button className="btn buybtn w-100">Buy at P2P</button>
                  </div>

                  <div ref={sectionRef}>
                    <Bitcoinmarket
                      data={marketData}
                      itemsPerPage={6}
                      currentPage={currentPage}
                      setCurrentPage={(data) => setCurrentPage(data)}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default Coindetail;
